import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useBidStore from "../../../store/bidStore";

import {
  Form,
  Input,
  Select,
  Radio,
  DatePicker,
  Checkbox,
  Button,
  notification,
  Spin,
  message,
  Modal,
} from "antd";
import ErrorLogout from "../../../helpers/ErrorLogout";
import ImageVideoUploader from "../../../helpers/imageVideoUploader/ImageVideoUploader";
import CategoryImageUploader from "../../../helpers/imageVideoUploader/CategoryImageUploader";
import moment from "moment";
import {
  approveBid,
  fetchCategory,
  getAllGroup,
  getSingleBid,
} from "../../../api/CommonRequest";
import BidScheduleModal from "./BidScheduleModal";
import GoogleMapLocationPicker from "../../googlemap/GoogleMapLocationPicker";
import DocumentUploader from "../../../helpers/imageVideoUploader/DocumentUploader";

const { TextArea } = Input;

function BidApprove({ edit }) {
  const navigate = useNavigate();
  const { bidData, clearBidData } = useBidStore();

  const tabItems = [
    { key: "Basic Info", label: "Basic Info" },
    { key: "Detailed Info", label: "Detailed Info" },
  ];

  const initail = {
    "Full Front View": [],
    "Odometer Reading": [],
    "Front Left Angle": [],
    "Front Right Angle": [],
    "Rear View": [],
  };

  const [loader, setLoader] = useState(true);
  const [activeTab, setActiveTab] = useState("Basic Info");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [formFields, setFormFields] = useState([]);
  const [basicInfoData, setBasicInfoData] = useState({});
  const [detailedInfoData, setDetailedInfoData] = useState({});
  const [images, setImages] = useState(
    bidData?.productImage ? bidData?.productImage : []
  );
  const [galleryImages, setGalleryImages] = useState(
    bidData?.galleryImages ? bidData?.galleryImages : initail
  );
  const [imageError, setImageError] = useState("");
  const [bidID, setBidID] = useState();
  const [bidDetails, setBidDetails] = useState();
  const [loaderGroup, setLoaderGroup] = useState(false);
  const [approveModal, setApproveModal] = useState(false);
  const [groupList, setGroupList] = useState([]);
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const [bidScheduleStatus, setBidScheduleStatus] = useState('now');
  const [bidStartDate, setBidStartDate] = useState(moment());
  const [bidEndDate, setBidEndDate] = useState();
  const [groupBid, setGroupBid] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [location, setLocation] = useState();
  const [locationError, setLocationError] = useState('');

  useEffect(() => {
    if (bidScheduleStatus === 'now') {
      setBidStartDate(moment()); // Set to current date
      form1.setFieldsValue({ startDate: moment() }); // Reset the start date in the form
    } else if (bidScheduleStatus === 'scheduleBid') {
      setBidStartDate(null); // Clear the start date for scheduling
      form1.setFieldsValue({ startDate: null });
    }
  }, [bidScheduleStatus, form1]);





  const handleBidType = (e) => {
    setBidScheduleStatus(e.target.value);
  };


  const onChangeGroupBid = (e) => {
    setGroupBid(e.target.value);

    groupCall()


  };


  const handleSelectChange = (value) => {
    console.log('Selected Value:', value);
  };


  const handleCancel = () => {
    setApproveModal(false)
  };

  const groupCall = async () => {
    try {
      setLoaderGroup(true)
      const { data } = await getAllGroup()
      if (data?.success) {
        setGroupList(data.groupList)
        setLoaderGroup(false)
      }
    } catch (error) {
      setLoaderGroup(false)
      console.log(error);
      console.log(error.message);
      if (error?.response?.status === 401) {
        ErrorLogout(error);
      }
    }
  };
  useEffect(() => {
    const getCategory = async () => {
      try {
        setLoader(true);
        const { data } = await fetchCategory();
        if (data?.success && data?.categoryData?.length) {
          setCategories(data.categoryData);
        } else {
          console.error(
            "No category data found or data format incorrect:",
            data
          );
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoader(false);
      }
    };
    getCategory();
  }, []);

  useEffect(() => {
    // Fetch initial form data if editing
    const loadInitialData = async () => {
      if (edit) {
        try {
          const { data } = await getSingleBid(edit);
          console.log(data);

          if (data.success) {
            const bidDetails = data.singleBid;
            setBidDetails(bidDetails);

            // Setting initial data in form
            form.setFieldsValue({
              productName: bidDetails.productName,
              category: bidDetails.category,
              subCategory: bidDetails.subCategory,
              expectedPrice: bidDetails.expectedPrice,
              ...bidDetails.detailedInfo,
              registrationYear: moment(
                bidDetails.detailedInfo.registrationYear,

              ), // Date field
              builtYear: moment(bidDetails.detailedInfo.builtYear), // Date field
            });

            // Set subcategories and fields dynamically
            const selectedCategory = categories.find(
              (cat) => cat._id === bidDetails.category
            );
            if (selectedCategory) {
              setSubCategories(selectedCategory.subCategories);
            }

            const selectedSubCategory = subCategories.find(
              (sub) => sub._id === bidDetails.subCategory
            );
            if (selectedSubCategory) {
              setFormFields(
                selectedSubCategory ? selectedSubCategory.form : []
              );
            }
            // Set subcategory form fields dynamically
            // setFormFields(bidDetails.subCategory.form);
            // setBasicInfoData(bidDetails);
            setImages(data?.singleBid?.productImage);
            setGalleryImages(data?.singleBid?.galleryImages);

            setLocation(data?.singleBid?.location || null);

            const documentsArray = data?.singleBid?.documents ? Object.values(data?.singleBid?.documents) : []
            setDocuments(documentsArray.length > 0 ? documentsArray[0] : []);
          } else {
            console.error("Failed to fetch bid details:", data);
          }
        } catch (error) {
          console.error("Error fetching bid details:", error);
        }
      }
    };
    loadInitialData();
  }, [edit, form]);

  useEffect(() => {
    if (categories && edit) {
      const selectedCategory = categories?.find(
        (cat) => cat._id === bidDetails?.category
      );
      if (selectedCategory) {
        setSubCategories(selectedCategory.subCategories);
      }
    }
  }, [categories]);

  useEffect(() => {
    const selectedSubCategory = subCategories?.find(
      (sub) => sub._id === bidDetails?.subCategory
    );
    if (selectedSubCategory) {
      setFormFields(selectedSubCategory ? selectedSubCategory.form : []);
    }
  }, [subCategories]);

  const handleCategoryChange = (value) => {
    // console.log(value, 'value cat');

    const selectedCategory = categories.find((cat) => cat._id === value);
    setSubCategories(selectedCategory ? selectedCategory.subCategories : []);
    form.setFieldsValue({ subCategory: null }); // Reset subcategory when category changes
    setFormFields([]);
  };

  const handleSubCategoryChange = (value) => {
    const selectedSubCategory = subCategories.find((sub) => sub._id === value);
    setFormFields(selectedSubCategory ? selectedSubCategory.form : []);
  };

  const validateAndNext = async () => {
    try {
      const values = await form.validateFields([
        "productName",
        "category",
        "subCategory",
        "expectedPrice",
      ]);
      setBasicInfoData(values); // Save "Basic Info" data to state

      if (!location || !location?.lat || !location?.lng) {
        setLocationError("select the location")
        throw new Error("location is required.");
      } else {
        setLocationError("")
      }

      if (
        images?.length === 0 ||
        !images ||
        images.every((obj) => obj.status === "removed")
      ) {
        // let newErrors
        // newErrors.images = "At least one image is required.";
        // valid = false;
        console.log("haaaaa");

        setImageError("At least one image is required.");
        throw new Error("At least one image is required.");
        // message.error("At least one image is required.");
        // addBidData("error", newErrors);
      } else {
        setImageError("");

        setActiveTab("Detailed Info");
      }
    } catch (error) {
      notification.error({
        message: "Please complete required fields in Basic Info",
        description: error.message,
      });
    }
  };


  const onFinish = async (values) => {



    setDetailedInfoData(values)
    setApproveModal(true)
  }
  const onFinishApproval = async (val) => {
    const values = { ...basicInfoData, ...detailedInfoData };
    // console.log(basicInfoData, 'basicInfoData');
    // console.log(detailedInfoData, 'detailedInfoData');

    // console.log("Form submitted with values:", val);
    values.bidStart = val?.startDate ? val?.startDate : ''
    values.bidEnd = val?.endDate ? val?.endDate : ''
    values.type = val?.type ? "group" : "public"
    values.groupID = val?.groupID ? val?.groupID : ''
    values.initialPrice = val.initialPrice
    values.securityAmount = val.securityAmount
    values.minBidAmount = val.minBidAmount
    // console.log("Form submitted with values:", values);

    setLoader(true);
    values.images = images;
    values.gallery = galleryImages;
    values.location = location
    values.documents = documents

    // console.log(values, "values");

    const datas = new FormData();

    let imagesArray = [];
    values?.images?.forEach((item, index) => {
      // removing thd removed images
      if (item?.status !== "removed") {
        imagesArray.push(item);
      }
    });
    imagesArray.forEach((item, index) => {
      // If originFileObj exists and it's not empty
      if (
        item?.originFileObj &&
        item?.originFileObj?.type &&
        item?.status === "done"
      ) {
        // console.log(item.originFileObj, 'item.originFileObj');
        datas.append(`images`, item.originFileObj, `images-${index}`);
      }
    });

    {
      Object.keys(values.gallery).map((key) => {
        let imagesArray = [];
        values?.gallery[key]?.forEach((item, index) => {
          // removing thd removed images
          if (item?.status !== "removed") {
            imagesArray.push(item);
          }
        });
        imagesArray.forEach((item, index) => {
          // If originFileObj exists and it's not empty
          if (
            item?.originFileObj &&
            item?.originFileObj?.type &&
            item?.status === "done"
          ) {
            // console.log(item.originFileObj, 'item.originFileObj');
            datas.append("galleryImages", item.originFileObj, `${key}-${index}`);
          }
        });
      });
    }

    //document

    let documentArray = []
    values?.documents?.forEach((item, index) => {
      // removing thd removed images 
      if (item?.status !== 'removed') {
        documentArray.push(item)
      }
    });
    documentArray.forEach((item, index) => {
      // If originFileObj exists and it's not empty
      if (item?.uid && item?.type && item?.status === 'done') {
        // console.log(item.originFileObj, 'item.originFileObj');
        datas.append(`documents`, item, `document-${index}`);
      }
    });

    // Append the rest of the values to FormData
    Object.keys(values).forEach((key) => {
      datas.append(key, values[key]);
    });
    console.log(detailedInfoData, "detailedInfoData");

    datas.append("detailedInfoDetails", JSON.stringify(detailedInfoData));
    datas.append("imageDetails", JSON.stringify(values.images));
    datas.append("galleryDetails", JSON.stringify(values.gallery));
    datas.append('locationDetails', JSON.stringify(values.location))
    datas.append('documentDetails', JSON.stringify(values.documents))

    // const details = {
    //   detailedInfoID: bidDetails?.detailedInfoID,
    //   surveyID: bidDetails?.surveyID,
    // };
    // datas.append("details", JSON.stringify(details));
    // // console.log(datas, 'datas');

    try {
      const { data } = await approveBid(bidDetails._id, datas);
      if (data.success) {
        await message.success("Bid Approved Successfully");
        await clearBidData();
        navigate("/bid-list");
      }
    } catch (error) {
      console.log(error);
      console.log(error.message);
      message.error(error.message);

      if (error?.response?.status === 401) {
        ErrorLogout(error); // Handle unauthorized access
      }
    } finally {
      setLoader(false); // Stop loading state
    }
  };

  const handleDiscard = () => {
    clearBidData();
    navigate("/assignedSurvey");
  };

  const handleTabs = (key) => {
    if (key === "Detailed Info") {
      validateAndNext();
    } else {
      setActiveTab("Basic Info");
    }
  };

  return (
    <div className="p-4">
      <Spin spinning={loader}>
        <div className="lg:sticky top-0 pb-3 lg:z-10 bg-white">
          <div className="flex w-fit flex-wrap gap-2 mb-4 border border-[#9FACF0] p-2 rounded-[12px]">
            {tabItems.map((tab) => (
              <button
                key={tab.key}
                className={`px-4 py-2 rounded-md text-xs sm:text-sm md:text-base ${activeTab === tab.key
                  ? "bg-[#1955EB] text-white font-medium"
                  : "bg-[#F6F8FF] text-black font-medium"
                  }`}
                onClick={() => handleTabs(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="pt-[0px] space-y-10">
          <Form layout="vertical" form={form} onFinish={onFinish}>
            {activeTab === "Basic Info" && (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  <Form.Item
                    label="Product Name"
                    name="productName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the product name",
                      },
                    ]}
                  >
                    <Input placeholder="Enter Product Name" className="h-10" />
                  </Form.Item>

                  <Form.Item
                    label="Category"
                    name="category"
                    rules={[
                      { required: true, message: "Please select a category" },
                    ]}
                  >
                    <Select
                      onChange={handleCategoryChange}
                      placeholder="Select Category"
                      // value={selectedCategory}
                      className="h-10"
                      disabled={edit ? true : false}
                      options={categories?.map((item) => ({
                        label: item.name,
                        // value: item.value,
                        value: item._id,
                      }))}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Sub Category"
                    name="subCategory"
                    rules={[
                      {
                        required: true,
                        message: "Please select a subcategory",
                      },
                    ]}
                  >
                    <Select
                      onChange={handleSubCategoryChange}
                      placeholder="Select Subcategory"
                      className="h-10"
                      disabled={edit ? true : false}
                      options={subCategories?.map((item) => ({
                        label: item.name,
                        // value: item.value,
                        value: item._id,
                      }))}
                    />
                  </Form.Item>

                  <Form.Item
                    label="Expected Price"
                    name="expectedPrice"
                    rules={[
                      {
                        required: true,
                        message: "Please enter the expected price",
                      },
                    ]}
                  >
                    <Input
                      type="number"
                      placeholder="Enter Expected Price"
                      className="h-10"
                      disabled={edit ? true : false}

                    />
                  </Form.Item>
                </div>

                <div className='flex flex-col items-center'>
                  <h1 className='font-bold text-xl my-4 w-full'>Location </h1>
                  <div className='flex items-center gap-5'>

                    {(location?.lat && location?.lng) && (
                      <div className="mt-4 p-4 bg-white rounded-lg shadow">
                        <h3 className="font-semibold mb-2">Selected Location</h3>
                        <div className="grid grid-cols-2 gap-4">
                          <div>
                            <p className="text-sm text-gray-600">Latitude</p>
                            <p className="font-mono">{location?.lat?.toFixed(6)}</p>
                          </div>
                          <div>
                            <p className="text-sm text-gray-600">Longitude</p>
                            <p className="font-mono">{location?.lng?.toFixed(6)}</p>
                          </div>
                        </div>
                      </div>
                    )}
                    <GoogleMapLocationPicker location={location} setLocation={setLocation} />
                  </div>

                  {locationError &&
                    <p className="flex justify-start p-1 text-red-500">{locationError}</p>
                  }
                </div>

                <div className="flex flex-col items-center">
                  <h1 className="font-bold text-xl my-4 w-full">Images </h1>
                  <ImageVideoUploader
                    images={images}
                    setImages={setImages}
                    productID={bidID}
                    identifier={"image"}
                  />
                  {imageError && (
                    <p className="flex justify-start p-1 text-red-500">
                      {imageError}
                    </p>
                  )}
                </div>

                <div className="flex flex-col sm:flex-row justify-between items-center mt-8 gap-4">
                  <Button
                    className="text-[#313131] w-full sm:w-1/2 border-[#313131] rounded-[8px] h-10 text-xs sm:text-sm md:text-base font-semibold hover:border-gray-400"
                    onClick={handleDiscard}
                  >
                    Discard
                  </Button>
                  <Button
                    type="primary"
                    className="bg-[#1955EB] w-full sm:w-1/2 hover:border-[#1955EB] text-xs sm:text-sm md:text-base font-semibold hover:bg-white h-10 text-white"
                    onClick={validateAndNext}
                  >
                    Next
                  </Button>
                </div>
              </>
            )}

            {activeTab === "Detailed Info" && (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {formFields.map((field, index) => (
                    <Form.Item
                      key={index}
                      label={field.label}
                      name={field.name}
                      rules={[
                        {
                          required: field.required,
                          message: `Please enter ${field.label}`,
                        },
                      ]}
                    >
                      {field.type === "text" && (
                        <Input
                          placeholder={`Enter ${field.label}`}
                          className="h-10"
                        />
                      )}
                      {field.type === "number" && <Input type={field?.type} placeholder={`Enter ${field.label}`} className='h-10' />}
                      {field.type === "textarea" && (
                        <TextArea
                          rows={4}
                          placeholder={`Enter ${field.label}`}
                        />
                      )}
                      {field.type === "select" && (
                        <Select
                          placeholder={`Select ${field.label}`}
                          className="h-10"
                          options={field.values.map((item) => ({
                            label: item.label,
                            value: item.value,
                          }))}
                        />
                      )}
                      {field.type === "radio" && (
                        <Radio.Group>
                          {field.values.map((option, i) => (
                            <Radio key={i} value={option}>
                              {option}
                            </Radio>
                          ))}
                        </Radio.Group>
                      )}
                      {field.type === "date" && (
                        <DatePicker
                          picker={field.pickingType}
                          placeholder={`Select ${field.label}`}
                          className="h-10 w-full"
                        />
                      )}
                      {field.type === "checkbox" && (
                        <Checkbox.Group options={field.values} />
                      )}
                    </Form.Item>
                  ))}
                </div>

                <DocumentUploader documents={documents} setDocuments={setDocuments} />

                <CategoryImageUploader
                  images={galleryImages}
                  setImages={setGalleryImages}
                  bidID={bidDetails?._id}
                  edit={edit}
                />

                <div className="flex w-full flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4 mt-6">
                  <Button
                    className="border-slate-400 border h-10 w-full sm:w-1/2 hover:text-black text-base font-semibold text-black rounded-md px-4 py-2"
                    onClick={() => setActiveTab("Basic Info")}
                  >
                    Back
                  </Button>
                  <Button
                    type="primary"
                    // loading={loader}
                    htmlType="submit"
                    className="bg-[#1955EB] h-10 w-full sm:w-1/2 hover:border-[#1955EB] hover:bg-transparent text-white text-base font-semibold rounded-md px-4 py-2"
                  >
                    Submit
                  </Button>
                </div>
              </>
            )}
          </Form>
        </div>
      </Spin>



      <BidScheduleModal approveModal={approveModal} handleCancel={handleCancel} onFinishApproval={onFinishApproval} status={bidDetails?.status} />

    </div>
  );
}

export default BidApprove;
